import { string, object, number } from "yup";

const addressSchema = object().shape({
  rue: string().required("Addresse : le rue est obligatoire"),
  ville: string().required("Addresse : la ville est obligatoire"),
  codePostale: number()
    .typeError("Addresse : le code postale doit etre un nombre ")
    .min(1, "Addresse : le code postale est invalide")
    .required("Addresse : le code postale est obligatoire"),
  pays: string()
});

export const createAddressSchema = (t) => object().shape({
  rue: string().required(t("validation.address_rue_required")),
  ville: string().required(t("validation.address_ville_required")),
  codePostale: number()
    .typeError(t("validation.address_code_postal_required"))
    .min(1, t("validation.address_code_postal_required"))
    .required(t("validation.address_code_postal_required")),
  pays: string()
});

export default addressSchema;
